<template>
  <div>
    <div v-if="detail_loader"
         style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap>
        <v-flex xs12 sm8 md8 class="text-xs-left">
          <!-- <h2>Create Workspace</h2> -->
        </v-flex>

      </v-layout>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 class="text-xs-right" mt-3>
          <v-menu offset-y>
            <v-btn slot="activator" color="rgb(248 71 6)" class="white--text yatri_button">
              <router-link to="/news" class="white--text">
                <v-icon color="#bbbbc6" class="white--text">list</v-icon>
                &nbsp&nbsp News List
              </router-link>
            </v-btn>
          </v-menu>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-md
                           style="margin-left:4px;line-height: 20px;text-align: -webkit-left;padding-bottom: 10px;">
                <v-layout class="index_header" row wrap style="padding: 0px 0px 0px 0px; margin-bottom: 20px;">
                  <v-flex xs12 sm12 md12 lg1 style="display:flex;"></v-flex>
                  <v-flex xs12 sm12 md12 lg11
                          style="display:flex; align-items: center; flex-wrap: wrap; justify-content: end;">

                    <v-flex sm12 md6 lg3>
                      <v-btn slot="activator" color="rgb(248 71 6)"
                             class="white--text yatri_button" style="height: 50px;">
                        <router-link :to="{name:'newsUpdate',params:{id:this.$route.params.id } }" class="white--text">
                          <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon>
                          Edit
                        </router-link>
                      </v-btn>
                    </v-flex>

                    <v-flex sm12 md6 lg3 v-if="news_detail.status == 'draft'">
                      <v-btn slot="activator" color="rgb(248 71 6)" class="white--text yatri_button"
                             @click="changeStatus('Publish')" style="height: 50px;">
                        <v-icon color="#bbbbc6" class="white--text mr-2">publish</v-icon>
                        Publish
                      </v-btn>
                    </v-flex>

                    <v-flex sm12 md6 lg4 v-else-if="news_detail.status == 'published'">
                      <v-btn slot="activator" color="rgb(248 71 6)" class="white--text yatri_button"
                             @click="changeStatus('Notify')" style="height: 50px;">
                        <v-badge v-model="showBadge" color="rgba(76, 151, 229, 0)">
                          <template v-slot:badge>
                            <span>({{ notification_log_count }})</span>
                          </template>
                          <v-icon color="#bbbbc6" class="white--text mr-2">notifications</v-icon>
                        </v-badge>

                        Send Notification
                      </v-btn>
                    </v-flex>

                    <v-flex sm12 md6 lg3 v-else-if="news_detail.status == 'archived'">
                      <v-btn slot="activator" color="rgb(248 71 6)" class="white--text yatri_button"
                             @click="changeStatus('Unarchive')" style="height: 50px;">
                        Unarchive
                      </v-btn>
                    </v-flex>

                    <v-flex sm12 md6 lg3 v-if="news_detail.status == 'published'">
                      <v-btn slot="activator" color="rgb(248 71 6)" class="white--text yatri_button"
                             @click="changeStatus('Archive')" style="height: 50px;">
                        <v-icon color="#bbbbc6" class="white--text mr-2">archive</v-icon>
                        Archive
                      </v-btn>
                    </v-flex>

                    <v-flex sm12 md6 lg2>
                      <v-btn slot="activator" color="rgb(248 71 6)" class="white--text yatri_button"
                             @click="delete_news = true" style="height: 50px;">
                        <v-icon color="#bbbbc6" class="white--text mr-2">delete</v-icon>
                        Delete
                      </v-btn>
                    </v-flex>
                  </v-flex>

                </v-layout>

                <v-layout>
                  <v-flex xs12 md12 lg9>
                    <v-layout row wrap>
                      <v-flex xs12 md6 lg6>
                        <label>Commute Medium</label>
                        <v-autocomplete
                            :items="medium_types"
                            name="Commute Medium"
                            label="Select medium"
                            v-model="news_detail.commute_medium_id"
                            return-object
                            item-text="name"
                            item-value="id"
                            solo flat
                            disabled
                        >
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md4 lg4>
                        <label>City Name</label>
                        <v-autocomplete
                            :items="cityList"
                            name="City Name"
                            label="Select City"
                            v-model="news_detail.city_id"
                            item-text="name"
                            item-value="id"
                            v-validate="'required'"
                            solo flat disabled
                        >
                        </v-autocomplete>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs12 md6 lg10>
                        <label>Source URL </label>
                        <v-text-field
                            name="Source URL"
                            v-model="news_detail.source_url"
                            label="Source URL"
                            solo flat
                            clearable
                            disabled
                        ></v-text-field>
                      </v-flex>
                    </v-layout>


                    <v-layout row wrap>
                      <v-flex xs12 md6 lg10>
                        <label>Title </label>
                        <v-text-field
                            name="Title"
                            v-model="news_detail.title"
                            label="Title"
                            v-validate="'required'"
                            solo flat
                            :error-messages="errors.collect('createnews.Title')"
                            clearable
                            disabled
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 md6 lg10>
                        <label>Description: </label>
                        <v-textarea
                            name="Description"
                            v-model="news_detail.description"
                            rows="2"
                            v-validate="'required'"
                            solo flat
                            :error-messages="errors.collect('createnews.Description')"
                            clearable
                            disabled
                        >
                        </v-textarea>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 md6 lg10>
                        <!--                         <label>Source Name </label>-->
                        <!--                         <v-text-field-->
                        <!--                             name="Source URL"-->
                        <!--                             v-model="news_detail.source_name"-->
                        <!--                             label="Source Name"-->
                        <!--                             solo flat-->
                        <!--                             clearable-->
                        <!--                         ></v-text-field>-->
                        <label>Source Name</label>
                        <v-combobox
                            :items="news_sources"
                            name="Source"
                            label="Select Source"
                            v-model="news_detail.source_name"
                            item-text="name"
                            item-value="name"
                            solo flat
                            disabled
                        >
                        </v-combobox>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs12 md8 lg10 style="display: flex; flex-wrap: wrap; padding-bottom: 23px !important;">
                        <label>Image: </label>
                        <v-flex xs12 sm6 md2 lg1></v-flex>
                        <v-flex xs12 sm6 md3 lg3 class="ImageDisplay">
                          <v-img class="figure-img img-fluid rounded" :src="news_detail.image_url != null ?
                      storage_path() + news_detail.image_url : storage_path(news_detail.image_url) + default_image_path"></v-img>
                        </v-flex>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs12 md12 lg8 style="display: flex;">
                        <v-flex xs12 md4 lg4>
                          <v-checkbox
                              v-model="news_detail.is_scheduled"
                              label="Is Scheduled" disabled
                          ></v-checkbox>
                        </v-flex>

                        <v-flex xs12 md8 lg8 v-if="news_detail.is_scheduled == 1">
                          <label>Scheduled At: </label>
                          <v-text-field
                              v-model="news_detail.scheduled_at"
                              solo flat
                              disabled
                              name="Scheduled At"></v-text-field>
                        </v-flex>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs12 md6 lg10>
                        <label>Body: </label>
                        <vue-editor
                            name="news Body"
                            v-model="news_detail.body"
                            label="news Body"
                            solo flat
                            disabled
                        ></vue-editor>
                      </v-flex>

                    </v-layout>
                  </v-flex>
                  <v-flex xs12 md8 lg4 v-show="$vuetify.breakpoint.lg || $vuetify.breakpoint.md"
                          v-if="news_detail.status == 'published'">
                    <!--                  <v-layout row wrap>-->
                    <v-card style="background-color: #ECEFF1; border-radius: 7px;">
                      <v-layout row>
                        <v-flex lg12 md12>
                          <v-card-title primary-title style="padding-top: 13px; !important;">
                            <div style="font-size: 17px; font-variant: common-ligatures;font-weight: 400;">Recent
                              Notification Log
                            </div>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <div v-if="notification_loader">
                        <v-progress-linear indeterminate style="height: 4px; margin-top: 0px;"></v-progress-linear>
                      </div>
                      <div v-else>
                        <v-card-actions class="pa-3" v-if="notification_log_count == 0">
                          Notification not trigger yet..!!
                        </v-card-actions>
                        <v-card-actions v-else>
                          <v-card style="border-radius: 7px;">
                            <v-list two-line>
                              <template v-for="(item, index) in notification_logs">
                                <v-list-tile
                                    :key="item.id"
                                    avatar
                                    ripple>
                                  <v-list-tile-action>
                                    <v-icon
                                        color="#fe4134">
                                      event_available
                                    </v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title>{{ "Notification triggered at :" }}</v-list-tile-title>
                                    <v-list-tile-sub-title class="text--primary">
                                      {{ moment(item.created_at).format("ddd, Do MMM YYYY HH:mm A") }}
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                                <v-divider
                                    v-if="index + 1 < notification_logs.length"
                                    :key="index"
                                ></v-divider>
                              </template>
                            </v-list>
                          </v-card>
                        </v-card-actions>
                      </div>
                    </v-card>
                    <!--                  </v-layout>-->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog
          v-model="status_model"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to {{ this.news_status }} this news?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" small @click="updateStatus()">OK</v-btn>
              <v-btn color="black" small flat type="reset" @click="status_model = false">Cancel</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="delete_news"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to delete this news?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="deleteNews()">Delete</v-btn>
              <v-btn small color="black" flat type="reset" @click="delete_news = !delete_news">Cancel</v-btn>

            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-snackbar
          :color="snackBar.color"
          :top="snackBar.top"
          :bottom="snackBar.bottom"
          :left="snackBar.left"
          :right="snackBar.right"
          v-model="snackBar.show"
      >
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
import {VueEditor, Quill} from "vue2-editor";

const Block = Quill.import("blots/block");
Block.tagName = "DIV";
Quill.register(Block, true);
export default {
  created() {
  },
  computed: {
    // workspaceRequestCode:function(){
    //  return this.announcement_detail.office_id.name + '/'+ this.announcement_detail.tower_id.name + '/' + this.announcement_detail.wing_id.name +'/'+this.announcement_detail.type+'/'+this.announcement_detail.number;
    // }
  },
  components: {
    VueEditor,
  },
  watch: {},

  methods: {
    strippedContent: function (string) {
      if (string !== undefined && string !== null) {
        return string.replace(/<\/?[^>]+>/ig, " ");
      }

    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },


    getNewsDetails: function () {
      this.detail_loader = true;
      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/news/` +
              this.$route.params.id, {headers: this.$headers}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.news_detail = response.data.news;
              this.getNotificationLogs(this.news_detail.id);

              this.detail_loader = false;

            }
          })
          .catch((error) => {
            console.log(error);
          });
    },

    getTypeList: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/commute-mediums`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.medium_types = response.data.types;
            }
          }).catch((error) => {
        this.snackBar.message = "Something went wrong";
        this.snackBar.show = true;
      })
    },
    getSources: function () {
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/news-sources`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.news_sources = response.data.list;
            }
          }).catch((error) => {
        this.snackBar.message = "Something went wrong";
        this.snackBar.show = true;
      })
    },
    changeStatus: function (value) {
      this.news_status = value;
      this.status_model = true;
    },
    updateStatus: function () {
      this.detail_loader = true;
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/change-news-status`, {
        news_id: this.$route.params.id,
        status: this.news_status
      }, {headers: this.$headers}).then((response) => {

        if (response.data.status == 1) {
          this.detail_loader = false;
          this.response_message = response.data.message;
          this.response_status = response.data.status;
          this.status_model = false;
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
          this.getTypeList();
          this.getNewsDetails();
        }
        if (response.data.status == 2) {
          this.response_message = response.data.message;
          this.response_status = response.data.status;
          this.status_model = false;
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
        }
      }).catch((error) => {
        this.snackBar.message = "Something went wrong";
        this.snackBar.show = true;
      }).finally(() => {

      });
    },

    deleteNews: function () {
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/delete-news`, {news_id: this.$route.params.id}, {headers: this.$headers}).then((response) => {
        if (response.data.status == 1) {
          this.response_message = response.data.message;
          this.response_status = response.data.status;
          this.delete_news = false;
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
          this.$router.push('/news');
        }
      }).catch((error) => {
        this.snackBar.message = "Something went wrong";
        this.snackBar.show = true;
      }).finally(() => {

      });
    },
    getNotificationLogs(id) {
      this.notification_loader = true;
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-notification-logs/` + id,
              {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.notification_loader = false;
              this.notification_logs = response.data.data;
              this.notification_log_count = response.data.log_count;
            }
          }).catch((error) => {
        this.notification_loader = false;
        this.snackBar.message = "Something went wrong";
        this.snackBar.show = true;
      })
    },
    getCityList(){
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id' : 0, 'name':"ALL"})
            }
          });
    }

  },
  data: () => {
    return {
      status_model: false,
      delete_news: false,
      news_status: '',
      news_detail: {},
      detail_loader: false,
      valid: false,
      medium_types: [],
      local_lines: [],
      train_codes: [],
      auth_user: {
        roles: [{}]
      },
      workspaceRequestCode: "",
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
      },
      news_sources: [],
      default_image_path: '/serviceAlerts/no_image.png',
      showBadge: true,
      notification_log_count: 0,
      notification_logs: [],
      notification_loader: false,
      config: {},
      cityList: [],
    };
  },

  mounted() {
    this.getCityList();
    this.getNewsDetails();
    this.getTypeList();
    this.getSources();
  },
};
</script>
<style>
.v-badge__badge {
  right: -1px !important;
  top: -9px !important;
  background-color: rgba(76, 151, 229, 0) !important;
  border-color: rgba(76, 151, 229, 0) !important;
}
</style>

